import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { UiTranslationService } from '@core/services/ui-translation.service';
import { TrainAsset, TrainFlashcard } from '../../../deck-train.models';

@Component({
  selector: 'app-text-train-front',
  imports: [],
  templateUrl: './text-train-front.html',
  styleUrl: './text-train-front.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextTrainFront {
  private readonly deckTranslations =
    inject(UiTranslationService).namespace('deck');

  readonly card = input.required<TrainFlashcard>();
  readonly imageAsset = input<TrainAsset | null>(null);
  readonly canSpeakQuestion = input(false);
  readonly isQuestionAudioPlaying = input(false);
  readonly speak = output<void>();

  readonly t = this.deckTranslations.t;

  get imageAlt(): string {
    return (
      this.imageAsset()?.altText ||
      this.imageAsset()?.fileName ||
      this.t()['train.frontImage']
    );
  }
}
